// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"_6kmmDnSY13lHI84MxWS9h","container":"hOGNisJnGM-CmAv9nnJFO","text":"_1u5WDKymHpWxcxZS1TIplT","icon":"_3TzxCfru7CAffpjkJcsABb","button":"P9CGKfeO9XcXXzb9T32aK"};